<template>
  <div class="cs-app-wrap">
    <div v-if="! formSubmitted" class="cs-app-main">
      <UserDetails :user="user" :content="content.introduction"/>
      <SelectionTable :features="features" :selections="selections" :chosen="chosen" :totalCost="totalCost"
                      @selectionMade=handleSelectionMade
      />
      <SubmissionForm
        ref="subForm"
        :processing="processing"
        @submit="processSubmission($event)"
        v-if="selectionsComplete"

      />
      <StatusBar
        :cost="totalCost"
        :progress="selectionProgress"
      />
    </div>

    <div v-else class="cs-app-confirm">
      <h4>Submission complete.</h4>
      <p>Please check your email for your selections summary.</p>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

import StatusBar from "@/components/StatusBar";
import UserDetails from "@/components/UserDetails";
import SelectionTable from "@/components/SelectionTable";
import SubmissionForm from "@/components/SubmissionForm";

export default {
  name: "App",
  components: {
    UserDetails,
    StatusBar,
    SelectionTable,
    SubmissionForm,
  },
  data: function () {
    return {
      features: window.CS.features,
      selections: window.CS.selections,
      user: window.CS.user,
      content: window.CS.content,
      chosen: {},
      // saved: window.CS.saved,
      processing: false,
      formSubmitted: false,
    };
  },

  created() {
    this.setChosen();
  },

  methods: {


    setChosen() {
      for ( const key in this.features ) {
        this.chosen[ key ] = {
          selection: false,
          cost: 0,
        };
      }

      //load matching values from user
      if ( this.user.saved_progress ) {
        for ( const key in this.chosen ) {
          if ( key in this.user.saved_progress ) {
            this.chosen[ key ] = this.user.saved_progress[ key ];
          }
        }
      }

    },

    handleSelectionMade( selectionID, feature ) {
      if ( selectionID ) {
        this.chosen[ feature.ID ].selection = selectionID;
        this.chosen[ feature.ID ].cost = this.getSelectionCost( selectionID, feature );
      } else {
        this.chosen[ feature.ID ].selection = false;
        this.chosen[ feature.ID ].cost = 0;
      }
      this.saveProgress();

    },

    saveProgress() {
      axios
        .post( this.API_ROOT + 'save_progress/', {
          user: this.user.ID,
          chosen: this.chosen,
          //todo: make more comprehensive in case features and selection data changes
        } )
        .then()
        .catch( error => {
          console.log( error );
        } );
    },


    getSelectionCost( selectionID, feature ) {
      for ( const level of feature.levels ) {
        if ( level.selections.includes( selectionID ) ) {
          return parseInt( level.cost );
        }
      }

      return 0;
    },
    currentChosen( featureID ) {
      if ( Object.prototype.hasOwnProperty.call( this.chosen, featureID ) ) {
        return this.chosen[ featureID ].selection;
      }
      return false;
    },

    processSubmission( submission ) {
      this.processing = true;


      axios
        .post( this.API_ROOT + 'submit/', {
          user: this.user,
          chosen: this.chosen,
          features: this.features,
          selections: this.selections,
          signature: submission,
        } )
        .then( () => {
          this.processing = false;
          this.formSubmitted = true;
        } )
        .catch( error => {
          console.log( error );
        } );
    }
  }, //end methods
  computed: {
    totalCost() {
      let cost = 0;
      for ( let key in this.chosen ) {
        cost += this.chosen[ key ].cost;
      }
      return cost;
    },

    /**
     Returns how many selections we've made, e.g. 5/20
     * @returns {{total: number, completed: number}}
     */
    selectionProgress() {
      let count = 0;
      for ( let key in this.chosen ) {
        if ( this.chosen[ key ].selection ) {
          count++;
        }
      }
      return {
        completed: count,
        total: Object.keys( this.chosen ).length
      };
    },
    selectionsComplete() {
      return this.selectionProgress.completed === this.selectionProgress.total;
    }
  },
  watch: {
    selectionsComplete( newVal ) {
      if ( newVal ) {
        this.$nextTick( () => {
          console.log();
          this.$refs.subForm.$el.scrollIntoView( { behavior: 'smooth' } );
        } );
      }
    }
  }

};
</script>

<style>

</style>
<style lang="scss">
@import 'src/scss/app.scss';
</style>
